<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]">
    <div class="w-100">
      <l-map ref="memMap" style="width: 100vw; height: 92.5vh;" :center="center" :zoom="zoom">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="memory.coords" :icon="icon" v-for="memory in memories" :key="memory.id">
          <l-popup>
            <div class="d-flex">
              <div class="w-100">
                <h5>
                  Souvenir de {{ memory.display_name }} <span class="text-muted">[{{ memory.movement }}]</span>
                </h5>
              </div>
            </div>
            <div class="w-100" v-if="memory.souvenir_content !== `/`">
              <div v-if="memory.souvenir_type == 'url'">
                <a :href="memory.souvenir_content">{{ memory.souvenir_content }}</a>
              </div>
              <div v-else-if="memory.souvenir_type == 'text'">
                {{ memory.souvenir_content }}
              </div>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
      <NextBtn class="send" :url="'/immersion02/' + (this.id + 1)" text="Terminer l'immersion" />
      <div class="info">
        <div class="bulle">
          <div class="cadre">
            <p>
              Maintenant, tu peux prendre le temps de découvrir les souvenirs d’autre explorêveurs et explorêveuses
              avant de terminer l’immersion !
            </p>
          </div>
        </div>
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NextBtn from "@/components/NextButton";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Service from "@/services/memoryMap";
import * as Sentry from "@sentry/browser";

export default {
  name: "IM_2_4",
  data: function () {
    return {
      id: 5,
      memories: [],
      scarfs: [],
      url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      attribution: `Fond de carte : &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>, Données : &copy; les contributeurs d'<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
      zoom: 6,
      center: [47.41322, -1.219482],
      bounds: null,
      icon: {}
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    }
  },
  created() {
    this.icon = Service.getIcon();
    Service.getAll().then(
      (m) => {
        this.memories = m;
      },
      function (err) {
        this.$bvToast.toast("Une erreur est survenue pendant le chargement des souvenirs", {
          title: "Oh non !",
          variant: "error"
        });
        Sentry.captureException(new Error(err));
      }
    );
  },
  components: { NextBtn, LMap, LTileLayer, LMarker, LPopup }
};
</script>

<style scoped lang="scss">
.send {
  position: absolute;
  bottom: 4vh;
  right: 2vw;
  z-index: 1000000;
}
.info {
  position: absolute;
  z-index: 1000;
  bottom: 3vh;
  left: 5vw;
  & img {
    height: 40vh;
  }
}
.bulle {
  position: absolute;
  bottom: 63vh;
  left: -4vw;
}
.cadre {
  position: absolute;
  background-color: white;
  width: 340px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 18%;
  width: 0;
  height: 0;
  transform: rotate(90deg);
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 60px solid white;
}
</style>
